<template>
  <v-card class="ma-3">
    <v-card-title primary-title>
      <h5 class="headline">Eventos</h5>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :pagination.sync="pagination"
        :items="events"
        :total-items="totalEvents"
        :loading="loading"
        :no-data-text="noDataText"
        :no-results-text="noResultsText"
        :rows-per-page-text="rowsPerPageText"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template class="test" slot="items" slot-scope="props">
          <tr @click="openEventDialog({ _id: props.item._id })">
            <td>{{ new Date(props.item.data.gps.date).toLocaleString() }}</td>
            <td class="text-xs-right">{{ props.item.name }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
    <event-dialog ref="eventDialog"/>
  </v-card>
</template>

<script>
import EventDialog from '@/components/EventDialog'

export default {
  name: 'events-table',
  props: {
    loading: Boolean,
    events: Array,
    totalEvents: Number
  },
  data: function () {
    return {
      pagination: {},
      headers: [
        { text: 'Fecha', align: 'left', sortable: false },
        { text: 'Evento', sortable: false }
      ],
      noDataText: 'No hay eventos para mostrar',
      noResultsText: 'No se han encontrado coincidencias',
      rowsPerPageText: 'Filas por página:',
      rowsPerPageItems: [5, 15, 25, 50, 75, 100]
    }
  },
  watch: {
    pagination: function (pagination) {
      const { page, rowsPerPage } = pagination
      this.$emit('update-pagination', { page, rowsPerPage })
    }
  },
  mounted: function () {
    const { page, rowsPerPage } = this.pagination
    this.$emit('update-pagination', { page, rowsPerPage })
  },
  components: {
    'event-dialog': EventDialog
  },
  methods: {
    openEventDialog: function ({ _id }) {
      console.log('event dialog...')
      console.log(_id)
      this.$refs.eventDialog.open({ eventId: _id })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Reports/EventsTable.vue